import type { ReactNode } from 'react';

export const symbol_plagiarism: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M448-294q20 0 40.5-5.5T528-317l90 90q7.82 8 19.91 8t20.09-7.86q8-7.85 8-20 0-12.14-8-20.14l-91-91q11-17 15.5-36.15T587-433q0-59-40-99t-99-40q-59 0-99 40t-40 99q0 59 40 99t99 40Zm-56.5-82.5Q369-399 369-433t22.5-56.5Q414-512 448-512t56.5 22.5Q527-467 527-433t-22.5 56.5Q482-354 448-354t-56.5-22.5ZM220-80q-24 0-42-18t-18-42v-680q0-24 18-42t42-18h336q12.44 0 23.72 5T599-862l183 183q8 8 13 19.28 5 11.28 5 23.72v496q0 24-18 42t-42 18H220Zm331-584v-156H220v680h520v-494H581q-12.75 0-21.37-8.63Q551-651.25 551-664ZM220-820v186-186 680-680Z"
		/>
	</svg>
);
